var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNologBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.753,
    height: 196.108,
    viewBox: "0 0 257.753 196.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.63,
    y1: 0.974,
    x2: 0.63,
    y2: -0.017,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3659",
    "data-name": "Gruppe 3659",
    transform: "translate(0.002 0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3784",
    "data-name": "Pfad 3784",
    d: "M131.617,90.33c-1.369,1.661-1.9,4-2.486,6.193-4.747,17.7-16.443,31.932-29.764,42.1-5.641,4.307-12.509,10.083-11.274,17.8.665,4.147,3.58,7.2,5.746,10.577a32.815,32.815,0,0,1,3.852,25.152c-2.463,9.633-9.348,18.622-7.217,28.362,1.314,6,5.776,10.263,10.065,13.93q10.038,8.576,20.715,16.068c4.772,3.348,9.848,6.605,15.409,7.03,4.9.375,9.693-1.486,14.342-3.323,4.062-1.606,8.227-3.278,11.507-6.5,2.141-2.1,3.847-4.812,6.226-6.53,5.586-4.037,12.761-1.479,19.166.25a66.733,66.733,0,0,0,45.672-4.182c22.062-10.368,38.877-32.139,60.457-43.821,9.278-5.024,19.371-8.142,27.962-14.612a52.235,52.235,0,0,0,12.291-13.3,57.534,57.534,0,0,0,8.994-35.3c-1.014-12.506-6.7-24.557-15.624-31.617-9.556-7.557-21.624-8.969-32.5-13.505-11.222-4.692-21.21-12.751-32.324-17.775A66.12,66.12,0,0,0,205.8,68.611c-12.1,6.121-24.367,20.4-37.848,21.485C158.348,90.845,139.117,81.232,131.617,90.33Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3785",
    "data-name": "Pfad 3785",
    d: "M951.78,290.182s-3.637-12.354.682-21.445a19.51,19.51,0,0,0,1.579-12.241,32.817,32.817,0,0,0-1.734-5.746",
    transform: "translate(-734.905 -203.491)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3786",
    "data-name": "Pfad 3786",
    d: "M952.474,218.9c0,1.514-2.748,5.9-2.748,5.9s-2.748-4.389-2.748-5.9a2.748,2.748,0,1,1,5.481,0Z",
    transform: "translate(-732.371 -177.383)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3787",
    "data-name": "Pfad 3787",
    d: "M970.519,249.086c-.822,1.272-5.519,3.468-5.519,3.468s.085-5.174.907-6.445a2.748,2.748,0,0,1,4.6,2.98Z",
    transform: "translate(-745.897 -199.186)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3788",
    "data-name": "Pfad 3788",
    d: "M966.8,303.354c-1.352.682-6.5.21-6.5.21s2.686-4.424,4.037-5.106a2.748,2.748,0,0,1,2.468,4.894Z",
    transform: "translate(-742.371 -239.122)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3789",
    "data-name": "Pfad 3789",
    d: "M956.778,347.559c-1.217.9-6.378,1.307-6.378,1.307s1.9-4.814,3.118-5.716a2.748,2.748,0,0,1,3.248,4.407Z",
    transform: "translate(-734.944 -272.507)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3790",
    "data-name": "Pfad 3790",
    d: "M939.06,261.8c1.087,1.054,6.146,2.148,6.146,2.148s-1.249-5.024-2.326-6.081a2.748,2.748,0,1,0-3.82,3.932Z",
    transform: "translate(-725.703 -208.144)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3791",
    "data-name": "Pfad 3791",
    d: "M926.475,311.794c1.352.682,6.5.21,6.5.21s-2.686-4.424-4.037-5.106a2.748,2.748,0,0,0-2.468,4.894Z",
    transform: "translate(-715.988 -245.454)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3792",
    "data-name": "Pfad 3792",
    d: "M922.181,362.688c1.217.9,6.378,1.307,6.378,1.307s-1.9-4.814-3.118-5.716a2.748,2.748,0,1,0-3.248,4.407Z",
    transform: "translate(-712.793 -283.639)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3793",
    "data-name": "Pfad 3793",
    d: "M952.474,218.9c0,1.514-2.748,5.9-2.748,5.9s-2.748-4.389-2.748-5.9a2.748,2.748,0,1,1,5.481,0Z",
    transform: "translate(-732.371 -177.383)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3794",
    "data-name": "Pfad 3794",
    d: "M970.519,249.086c-.822,1.272-5.519,3.468-5.519,3.468s.085-5.174.907-6.445a2.748,2.748,0,0,1,4.6,2.98Z",
    transform: "translate(-745.897 -199.186)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3795",
    "data-name": "Pfad 3795",
    d: "M966.8,303.354c-1.352.682-6.5.21-6.5.21s2.686-4.424,4.037-5.106a2.748,2.748,0,0,1,2.468,4.894Z",
    transform: "translate(-742.371 -239.122)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3796",
    "data-name": "Pfad 3796",
    d: "M956.778,347.559c-1.217.9-6.378,1.307-6.378,1.307s1.9-4.814,3.118-5.716a2.748,2.748,0,0,1,3.248,4.407Z",
    transform: "translate(-734.944 -272.507)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3797",
    "data-name": "Pfad 3797",
    d: "M939.06,261.8c1.087,1.054,6.146,2.148,6.146,2.148s-1.249-5.024-2.326-6.081a2.748,2.748,0,1,0-3.82,3.932Z",
    transform: "translate(-725.703 -208.144)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3798",
    "data-name": "Pfad 3798",
    d: "M926.475,311.794c1.352.682,6.5.21,6.5.21s-2.686-4.424-4.037-5.106a2.748,2.748,0,0,0-2.468,4.894Z",
    transform: "translate(-715.988 -245.454)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3799",
    "data-name": "Pfad 3799",
    d: "M922.181,362.688c1.217.9,6.378,1.307,6.378,1.307s-1.9-4.814-3.118-5.716a2.748,2.748,0,1,0-3.248,4.407Z",
    transform: "translate(-712.793 -283.639)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3800",
    "data-name": "Pfad 3800",
    d: "M1012.78,369.182s-3.637-12.354.682-21.445a19.511,19.511,0,0,0,1.579-12.241,32.812,32.812,0,0,0-1.734-5.746",
    transform: "translate(-780.666 -262.755)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3801",
    "data-name": "Pfad 3801",
    d: "M1013.473,297.9c0,1.514-2.748,5.9-2.748,5.9s-2.748-4.389-2.748-5.9a2.748,2.748,0,1,1,5.481,0Z",
    transform: "translate(-778.132 -236.647)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3802",
    "data-name": "Pfad 3802",
    d: "M1031.548,327.108c-.822,1.272-5.509,3.465-5.509,3.465s.085-5.174.907-6.445a2.748,2.748,0,1,1,4.6,2.98Z",
    transform: "translate(-791.688 -257.472)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3803",
    "data-name": "Pfad 3803",
    d: "M1027.8,381.809c-1.352.682-6.5.21-6.5.21s2.686-4.424,4.037-5.106a2.748,2.748,0,1,1,2.468,4.894Z",
    transform: "translate(-788.132 -297.841)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3804",
    "data-name": "Pfad 3804",
    d: "M1017.778,426.559c-1.217.9-6.378,1.307-6.378,1.307s1.9-4.814,3.118-5.716a2.748,2.748,0,0,1,3.248,4.407Z",
    transform: "translate(-780.705 -331.771)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3805",
    "data-name": "Pfad 3805",
    d: "M1000.906,341.625c1.087,1.054,6.146,2.148,6.146,2.148s-1.249-5.024-2.326-6.081a2.748,2.748,0,0,0-3.82,3.932Z",
    transform: "translate(-772.309 -268.229)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3806",
    "data-name": "Pfad 3806",
    d: "M987.475,390.794c1.352.682,6.5.21,6.5.21s-2.686-4.424-4.037-5.106a2.748,2.748,0,0,0-2.468,4.894Z",
    transform: "translate(-761.749 -304.718)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3807",
    "data-name": "Pfad 3807",
    d: "M983.181,441.688c1.217.9,6.378,1.307,6.378,1.307s-1.9-4.814-3.118-5.716a2.748,2.748,0,1,0-3.248,4.407Z",
    transform: "translate(-758.554 -342.904)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3808",
    "data-name": "Pfad 3808",
    d: "M1013.473,297.9c0,1.514-2.748,5.9-2.748,5.9s-2.748-4.389-2.748-5.9a2.748,2.748,0,1,1,5.481,0Z",
    transform: "translate(-778.132 -236.647)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3809",
    "data-name": "Pfad 3809",
    d: "M1031.548,327.108c-.822,1.272-5.509,3.465-5.509,3.465s.085-5.174.907-6.445a2.748,2.748,0,1,1,4.6,2.98Z",
    transform: "translate(-791.688 -257.472)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3810",
    "data-name": "Pfad 3810",
    d: "M1027.8,381.809c-1.352.682-6.5.21-6.5.21s2.686-4.424,4.037-5.106a2.748,2.748,0,1,1,2.468,4.894Z",
    transform: "translate(-788.132 -297.841)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3811",
    "data-name": "Pfad 3811",
    d: "M1017.778,426.559c-1.217.9-6.378,1.307-6.378,1.307s1.9-4.814,3.118-5.716a2.748,2.748,0,0,1,3.248,4.407Z",
    transform: "translate(-780.705 -331.771)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3812",
    "data-name": "Pfad 3812",
    d: "M1000.906,341.625c1.087,1.054,6.146,2.148,6.146,2.148s-1.249-5.024-2.326-6.081a2.748,2.748,0,0,0-3.82,3.932Z",
    transform: "translate(-772.309 -268.229)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3813",
    "data-name": "Pfad 3813",
    d: "M987.475,390.794c1.352.682,6.5.21,6.5.21s-2.686-4.424-4.037-5.106a2.748,2.748,0,0,0-2.468,4.894Z",
    transform: "translate(-761.749 -304.718)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3814",
    "data-name": "Pfad 3814",
    d: "M983.181,441.688c1.217.9,6.378,1.307,6.378,1.307s-1.9-4.814-3.118-5.716a2.748,2.748,0,1,0-3.248,4.407Z",
    transform: "translate(-758.554 -342.904)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 123.446,
    cy: 19.871,
    rx: 123.446,
    ry: 19.871,
    transform: "matrix(0.995, -0.097, 0.097, 0.995, 8.166, 120.158)",
    fill: "#b9f6ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3815",
    "data-name": "Pfad 3815",
    d: "M346.379,361.047c4.619-9.468,3.665-24.88,3.173-30.111-.107-1.144-.192-1.8-.192-1.8s-4.072-.642-2.571-5.571c.734-2.413-1.874-3.747-4.722-4.479a33.253,33.253,0,0,0-6.206-.877l-39.444-2.436h0c-5.409-8.584-16.051-7.2-16.051-7.2l-16.223-1.089-6.51.349-4.689,1.074a28.468,28.468,0,0,0-3.2,3.231,2.586,2.586,0,0,0-.267.167l-.075.055v.152l-.042.033L249.269,315l.052.04a7.285,7.285,0,0,0,3.388,5.686c.032.157.062.317.092.485a13.208,13.208,0,0,1,.185,2.443h-.042c-1.174-.5-3.183.235-4.909,1.092H225.671a70.085,70.085,0,0,1,9.7-9.963v-4.931c-3.812-.19-37.3,15.9-44.645,19.451l-.325.157-37.735,1.169a58.149,58.149,0,0,0-17.987,2.6,51.186,51.186,0,0,0-22.524,14.39,42.075,42.075,0,0,0-6.41,8.934l.042.34-.042.087.06.052,1.017,8.024.7,5.521c-4.862,3.143,1.436,4.4,1.436,4.4,6,5.141,15.641,4.929,15.641,4.929,2.356,3.215,9.213,2.785,9.213,2.785h36a87.222,87.222,0,0,1,2.248-9.793c1.536,11.065,10.268,19.541,20.805,19.541a19.445,19.445,0,0,0,2.338-.142,19.444,19.444,0,0,0,2.338.142c10.66,0,19.469-8.676,20.855-19.926h1.761a39.26,39.26,0,0,1-1.706,7.392c32.354-9.428,92.563-13.927,92.563-13.927q.375-3.56.822-6.868c2.481,6.158,8.1,10.457,14.649,10.457a14.784,14.784,0,0,0,1.779-.11,14.779,14.779,0,0,0,1.779.11c7.772,0,14.24-6.063,15.7-14.1a36.749,36.749,0,0,1,.33,4.279c-.277,1.364-.52,2.236-.552,2.358q.292-.535.555-1.094v.445c-.06.25-.1.39-.115.437l.11-.2v.327A9.757,9.757,0,0,1,346.379,361.047Z",
    transform: "translate(-101.249 -243.336)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2701",
    "data-name": "Rechteck 2701",
    width: 74.172,
    height: 29.921,
    transform: "translate(167.183 83.691)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3816",
    "data-name": "Pfad 3816",
    d: "M593.73,276.444l10.535,23.6,20.863-1.264.842-9.693.632-11.379L597.1,275.6Z",
    transform: "translate(-445.406 -206.766)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3817",
    "data-name": "Pfad 3817",
    d: "M681.68,325.856s4-3.792,8.851-4.637,21.072.842,21.072.842l2.318,4-.435,1.9Z",
    transform: "translate(-533.356 -256.178)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2702",
    "data-name": "Rechteck 2702",
    width: 74.804,
    height: 21.914,
    transform: "translate(113.24 81.794)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3818",
    "data-name": "Pfad 3818",
    d: "M651.112,342.228a11.786,11.786,0,0,0-1.964-10.95l-6.53-4.557a.3.3,0,0,1-.02.045,8.494,8.494,0,0,1-1.776-3.443c-.02-.08-.037-.162-.057-.25a7.028,7.028,0,0,0,1.549-1.586,3.828,3.828,0,0,0,1.719-2.748,13.7,13.7,0,0,0,1.621-3.28,5.833,5.833,0,0,0,.165-.572,3,3,0,0,0,.165-1.122,3.067,3.067,0,0,0-.415-1.2,12.6,12.6,0,0,0-5.084-4.524,10.818,10.818,0,0,0-2.226-1.014,6.308,6.308,0,0,0-5.571,1.044,2.963,2.963,0,0,0-.907,1.054,2.886,2.886,0,0,0-.185.592,10.607,10.607,0,0,0-.237,1.054,1.813,1.813,0,0,1-.235.477c-.267.375-.722.657-.782,1.114a.759.759,0,0,0,0,.08.825.825,0,0,0-.095.28,1,1,0,0,0,.125.582.931.931,0,0,0,.05.085,6.931,6.931,0,0,0-.794,1.524,2.542,2.542,0,0,0-.265.165l-.073.052v.15l-.042.033-.092,2.421.05.04a7.162,7.162,0,0,0,3.33,5.593c.032.155.062.312.09.477a12.826,12.826,0,0,1,.18,2.641.9.9,0,0,1,0-.23c-1.806-.817-5.746,1.441-7.332,2.441h0a3.009,3.009,0,0,0-.667.432l-.027.02h0c-1.092.884-3.248,3.343-4.959,9.661-2.373,8.816-2.126,10.815-3.855,12.858s-3.445,16.441-3.445,16.441l3.48.937.445-1.429c4.137,3.772,12.017,1.429,12.017,1.429l3.371-1.9c1.776.64,7.437-1.207,7.437-1.207,4.342-1.534,3.966.4,7.116-4.732S651.112,342.228,651.112,342.228ZM633.6,368.792l8.019-24.875c.727,3.862-2.481,9.945-2.766,13.922C638.676,360.4,635.7,365.482,633.6,368.792Z",
    transform: "translate(-481.473 -241.525)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3819",
    "data-name": "Pfad 3819",
    d: "M721.912,343.78s1.4,5.319-2.748,6.245-1.414-2.391-1.414-2.391l4-3.895Z",
    transform: "translate(-559.752 -273.25)",
    fill: "#472727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3820",
    "data-name": "Pfad 3820",
    d: "M630.694,394.64s-3.083,1.249-5.349,9.663-2.041,10.313-3.672,12.269-3.3,15.681-3.3,15.681l3.263.879,2.84-9.173,7.812-24.233Z",
    transform: "translate(-485.862 -307.434)",
    fill: "#dde0e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3821",
    "data-name": "Pfad 3821",
    d: "M630.694,394.64s-3.083,1.249-5.349,9.663-2.041,10.313-3.672,12.269-3.3,15.681-3.3,15.681l3.263.879,2.84-9.173,7.812-24.233Z",
    transform: "translate(-485.862 -306.434)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3822",
    "data-name": "Pfad 3822",
    d: "M702.57,360.459s-12.906,6.56-11.017,2.281a10.649,10.649,0,0,0,.627-6,12.808,12.808,0,0,0-.812-2.9s8.774-6.94,8.259-1.274a10.842,10.842,0,0,0,.25,3.642A7.306,7.306,0,0,0,702.57,360.459Z",
    transform: "translate(-540.621 -274.202)",
    fill: "#db8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3823",
    "data-name": "Pfad 3823",
    d: "M699.859,356.227a6.745,6.745,0,0,1-6,1.249,6.824,6.824,0,0,1-1.711-.722,12.808,12.808,0,0,0-.812-2.9s8.774-6.94,8.259-1.274a10.839,10.839,0,0,0,.26,3.65Z",
    transform: "translate(-540.603 -278.21)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 6.755,
    cy: 6.755,
    r: 6.755,
    transform: "translate(146.841 81.175) rotate(-74.93)",
    fill: "#db8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3824",
    "data-name": "Pfad 3824",
    d: "M688.191,318.764a1.611,1.611,0,0,1-2.248-.592.97.97,0,0,1-.115-.555c.057-.435.487-.7.749-1.064.407-.582.33-1.379.625-2.026a2.847,2.847,0,0,1,.854-1,5.873,5.873,0,0,1,5.234-1.019,9.972,9.972,0,0,1,2.083.957,11.622,11.622,0,0,1,4.747,4.289,2.927,2.927,0,0,1,.385,1.142,3.246,3.246,0,0,1-.225,1.274,13.278,13.278,0,0,1-1.556,3.165,2.438,2.438,0,0,0-.809-.652.835.835,0,0,0-.959.177c-.217.277-.35.807-.68.682-.215-.08-.212-.377-.2-.607a3.469,3.469,0,0,0-1.232-2.616,10.312,10.312,0,0,0-2.533-1.556,10.66,10.66,0,0,0-2.2-1.164C689.23,317.438,688.818,318.377,688.191,318.764Z",
    transform: "translate(-536.464 -245.651)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3825",
    "data-name": "Pfad 3825",
    d: "M688.561,317.394a1.611,1.611,0,0,1-2.248-.592.969.969,0,0,1-.115-.555c.057-.435.487-.7.749-1.064.407-.582.33-1.379.625-2.026a2.847,2.847,0,0,1,.854-1,5.873,5.873,0,0,1,5.234-1.019,9.981,9.981,0,0,1,2.083.957,11.622,11.622,0,0,1,4.747,4.289,2.928,2.928,0,0,1,.385,1.142,3.248,3.248,0,0,1-.225,1.274,13.279,13.279,0,0,1-1.556,3.165,2.437,2.437,0,0,0-.809-.652.834.834,0,0,0-.959.177c-.217.277-.35.807-.679.682-.215-.08-.212-.377-.2-.607a3.469,3.469,0,0,0-1.232-2.616,10.311,10.311,0,0,0-2.533-1.556,10.663,10.663,0,0,0-2.2-1.164C689.6,316.065,689.188,317.007,688.561,317.394Z",
    transform: "translate(-536.742 -244.623)",
    fill: "#472727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3826",
    "data-name": "Pfad 3826",
    d: "M648.63,387.068s5.344-1.047,5.576-1.9l6.111,4.314a11.3,11.3,0,0,1,1.8,10.425s-1.531,13.213-4.509,18.117-4.894,6.039-8.974,7.523c0,0-3.717,2.69-5.011,2.72,0,0,6.643-9.626,6.927-13.415s3.32-9.6,2.656-13.278l-8.664,24.977s-14.819.73-16.288-4.079a6.446,6.446,0,0,0,1.017-3.777c-.232-1.9,5.466-16.2,5.466-16.2l2.728-14.914s5.4-3.77,7.545-2.79C645,384.767,644.606,386.629,648.63,387.068Z",
    transform: "translate(-493.274 -299.917)",
    fill: "#dde0e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3658",
    "data-name": "Gruppe 3658",
    transform: "translate(148.319 73.948)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3827",
    "data-name": "Pfad 3827",
    d: "M690.643,343.175h0c-1.319-1.8-3.835-.322-4.247-.065l-.647-.065c-.565-.615-2.3-2.248-3.922-1.047l-.07.052-.1,2.306.07.055a4.816,4.816,0,0,0,1.571.8,2.371,2.371,0,0,0,1.109.055,1.913,1.913,0,0,0,1.277-1l.337.022.25-.047a1.9,1.9,0,0,0,.9,1.284,3.9,3.9,0,0,0,2.815-.012l.085-.033.6-2.231ZM689.8,345.2a3.341,3.341,0,0,1-2.428,0,1.614,1.614,0,0,1-.75-1.214l-.03-.182-.547.112-.55-.02-.052.1a1.622,1.622,0,0,1-1.1.919,3.375,3.375,0,0,1-2.316-.734l.083-1.949c1.414-.952,2.973.592,3.422,1.1l.047.052.912.09.055-.038c.025-.015,2.291-1.536,3.582-.312a1.666,1.666,0,0,1,.177.192Z",
    transform: "translate(-681.66 -341.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3828",
    "data-name": "Pfad 3828",
    d: "M720.137,349.032l-4.247-.352-.35-.067.157-.59a1.677,1.677,0,0,0-.177-.192l.515.05,3.475.34Z",
    transform: "translate(-707.061 -346.266)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3829",
    "data-name": "Pfad 3829",
    d: "M690.823,342.535h0c-1.319-1.8-3.835-.322-4.247-.065l-.647-.065c-.565-.615-2.3-2.248-3.922-1.047l-.07.052-.1,2.306.07.055a4.817,4.817,0,0,0,1.571.8,2.371,2.371,0,0,0,1.109.055,1.914,1.914,0,0,0,1.276-1l.337.022.25-.047a1.9,1.9,0,0,0,.9,1.284,3.9,3.9,0,0,0,2.816-.013l.085-.032.6-2.231Zm-.847,2.029a3.341,3.341,0,0,1-2.428,0,1.614,1.614,0,0,1-.75-1.214l-.03-.182-.547.112-.542-.035-.052.1a1.621,1.621,0,0,1-1.092.929,3.375,3.375,0,0,1-2.316-.734l.083-1.949c1.414-.952,2.973.592,3.422,1.1l.047.052.912.09.055-.037c.025-.015,2.291-1.536,3.582-.312a1.676,1.676,0,0,1,.177.192Z",
    transform: "translate(-533.476 -267.141)",
    fill: "#472727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3830",
    "data-name": "Pfad 3830",
    d: "M720.342,348.392l-4.232-.352-.35-.067.157-.59a1.674,1.674,0,0,0-.177-.192l.515.05,3.475.34Z",
    transform: "translate(-558.907 -271.838)",
    fill: "#472727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2703",
    "data-name": "Rechteck 2703",
    width: 74.172,
    height: 29.921,
    transform: "translate(58.242 98.862)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 20.698,
    cy: 22.651,
    rx: 20.698,
    ry: 22.651,
    transform: "translate(71.49 103.077)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 20.698,
    cy: 22.651,
    rx: 20.698,
    ry: 22.651,
    transform: "translate(71.49 103.077)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 20.698,
    cy: 22.651,
    rx: 20.698,
    ry: 22.651,
    transform: "translate(76.089 103.077)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 9.198,
    cy: 9.198,
    r: 9.198,
    transform: "translate(87.128 116.644)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 2.761,
    cy: 2.761,
    r: 2.761,
    transform: "translate(93.566 123.082)",
    fill: "none",
    stroke: "#6f7d95",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "translate(95.637 120.324)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 99.128, 122.259)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_511",
    "data-name": "Ellipse 511",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "translate(100.712 126.652) rotate(-80)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_512",
    "data-name": "Ellipse 512",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "translate(98.598 129.329) rotate(-30)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_513",
    "data-name": "Ellipse 513",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "matrix(0.342, -0.94, 0.94, 0.342, 94.721, 130.728)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_514",
    "data-name": "Ellipse 514",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 91.629, 127.362)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_515",
    "data-name": "Ellipse 515",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "translate(91.532 124.021) rotate(-60)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3831",
    "data-name": "Pfad 3831",
    d: "M1013.909,433.13a59.564,59.564,0,0,1-2.673,10.225q.02-.5.025-.987V441.12a33.957,33.957,0,0,0-12.311-25.732A26.58,26.58,0,0,0,995,412.6h12.853s5.056,10.325,6.111,15.381A15.413,15.413,0,0,1,1013.909,433.13Z",
    transform: "translate(-768.402 -324.907)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_516",
    "data-name": "Ellipse 516",
    cx: 15.741,
    cy: 17.228,
    rx: 15.741,
    ry: 17.228,
    transform: "translate(207.851 91.432)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_517",
    "data-name": "Ellipse 517",
    cx: 15.741,
    cy: 17.228,
    rx: 15.741,
    ry: 17.228,
    transform: "translate(207.851 91.432)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_518",
    "data-name": "Ellipse 518",
    cx: 15.741,
    cy: 17.228,
    rx: 15.741,
    ry: 17.228,
    transform: "translate(211.349 91.432)",
    fill: "#4b5c7a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_519",
    "data-name": "Ellipse 519",
    cx: 6.995,
    cy: 6.995,
    r: 6.995,
    transform: "translate(219.745 101.753)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_520",
    "data-name": "Ellipse 520",
    cx: 2.098,
    cy: 2.098,
    r: 2.098,
    transform: "translate(224.642 106.649)",
    fill: "none",
    stroke: "#6f7d95",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "translate(226.216 104.551)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_522",
    "data-name": "Ellipse 522",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 228.872, 106.022)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "translate(230.075 109.365) rotate(-80)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_524",
    "data-name": "Ellipse 524",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "translate(228.47 111.401) rotate(-30)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "matrix(0.342, -0.94, 0.94, 0.342, 225.52, 112.464)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 223.167, 109.901)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "translate(223.097 107.361) rotate(-60)",
    fill: "#6f7d95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3833",
    "data-name": "Pfad 3833",
    d: "M115.9,529.2,114,514.24h22.546l11.589,10.325-5.688,13.276S119.5,534.048,115.9,529.2Z",
    transform: "translate(-107.494 -401.156)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3834",
    "data-name": "Pfad 3834",
    d: "M148.18,524.573l-5.688,13.275s-22.958-3.792-26.551-8.639l-.082-.652-1.749-13.835-.017-.137-.042-.335H136.6Z",
    transform: "translate(-107.531 -401.163)",
    fill: "#9e9e9e",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3835",
    "data-name": "Pfad 3835",
    d: "M488.3,330.365v4.846s-11.652,9.493-14.425,18.449a11.286,11.286,0,0,0-.537,4.519c1.054,9.9-30.338-8.009-30.338-8.009l1.4-.68C451.614,346.011,484.55,330.175,488.3,330.365Z",
    transform: "translate(-354.303 -263.215)",
    fill: "#7597ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3836",
    "data-name": "Pfad 3836",
    d: "M729.972,358.078s10.912-5.361,12.663-9.328c.235-.532.457-1.069.717-1.591,1.082-2.176,3.355-7.28,2.211-9.73-1.474-3.16,3.582.422,3.582.422l-2.95,14.957-7.165,4-9.271,1.274",
    transform: "translate(-569.424 -267.537)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3837",
    "data-name": "Pfad 3837",
    d: "M729.972,358.078s10.912-5.361,12.663-9.328c.235-.532.457-1.069.717-1.591,1.082-2.176,3.355-7.28,2.211-9.73-1.474-3.16,3.582.422,3.582.422l-2.95,14.957-7.165,4-9.271,1.274",
    transform: "translate(-558.256 -262.556)",
    fill: "#9e9e9e",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3838",
    "data-name": "Pfad 3838",
    d: "M148.158,524.58l-5.688,13.275s-22.958-3.792-26.551-8.639l-.082-.652c.092-.062.19-.127.292-.19,0,0,6.952,5.479,22.759,6.745,0,0,9.493-7.587-5.9-16.013,0,0-13.39.42-18.906-4.374l-.06-.05.042-.087q.055-.107.177-.335h22.326Z",
    transform: "translate(-107.509 -401.171)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3839",
    "data-name": "Pfad 3839",
    d: "M473.338,415.616c1.054,9.905-30.338-8.007-30.338-8.007l1.4-.679c.924.984,4.614,4.3,11.991,3.945,4.747-.232,11.954-.02,17.5.222a11.286,11.286,0,0,0-.55,4.519Z",
    transform: "translate(-354.303 -320.654)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3840",
    "data-name": "Pfad 3840",
    d: "M395.272,457.31v29.921h-13.78c.909-6.96.385-17.105-8.454-22.921a21.38,21.38,0,0,0-22.309-.665c-5.793,3.308-12.271,10.033-16.388,23.586H321.1V457.31Z",
    transform: "translate(-262.856 -358.448)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3841",
    "data-name": "Pfad 3841",
    d: "M1013.909,433.13a34.423,34.423,0,0,1-2.646,9.243q-.25.552-.545,1.077c.032-.122.27-.977.545-2.321,1.339-6.545,3.63-24.657-11.719-25.692-.2-.012-.4-.025-.594-.032A26.581,26.581,0,0,0,995,412.6h12.853s5.056,10.325,6.111,15.381A15.413,15.413,0,0,1,1013.909,433.13Z",
    transform: "translate(-768.402 -324.907)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3842",
    "data-name": "Pfad 3842",
    d: "M350.056,396.1c.2-.722,7.32-26.763-11.174-28.01-18.754-1.264-21.072,12.853-23.178,32.029,0,0-59.207,4.424-91.029,13.7,0,0,7.64-20.935-6.745-30.4a21.38,21.38,0,0,0-22.309-.665c-7.095,4.052-15.222,13.241-18.776,33.806h-35.4s-6.745.422-9.061-2.748c0,0-9.493.21-15.381-4.847,0,0-6.32-1.264-1.264-4.424,0,0,7.165,5.479,22.968,6.745,0,0,9.493-7.587-5.9-16.013,0,0-13.49.422-18.964-4.424a41.335,41.335,0,0,1,6.305-8.784,50.339,50.339,0,0,1,22.142-14.157,57.343,57.343,0,0,1,17.7-2.553l37.191-1.159s3.592,4.637,12.221,4.214,25.5.632,25.5.632h.167l34.705-1.571a22.083,22.083,0,0,0,2.95-.625c5.031-1.367,14.575-5.511,12.853-17.085l54.576,3.373a32.7,32.7,0,0,1,6.1.862c2.8.719,5.366,2.034,4.644,4.407-1.474,4.846,2.528,5.479,2.528,5.479s.085.647.19,1.771C354.109,370.952,355.09,386.891,350.056,396.1Z",
    transform: "translate(-107.323 -277.766)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3843",
    "data-name": "Pfad 3843",
    d: "M278.253,442.55s-22.759.21-37.723,13.49h8.429s23.6-6.111,29.289-10.957Z",
    transform: "translate(-202.414 -347.375)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3844",
    "data-name": "Pfad 3844",
    d: "M277.4,441.7s-22.759.21-37.723,13.49h8.429s23.6-6.111,29.289-10.957Z",
    transform: "translate(-201.776 -346.738)",
    fill: "#ffec9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3845",
    "data-name": "Pfad 3845",
    d: "M162.259,423.25v5.663l-19.171,8.851-2.968-.357A50.339,50.339,0,0,1,162.259,423.25Z",
    transform: "translate(-127.088 -332.897)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3846",
    "data-name": "Pfad 3846",
    d: "M161.4,422.41v5.663l-19.174,8.849-2.968-.357A50.338,50.338,0,0,1,161.4,422.41Z",
    transform: "translate(-126.443 -332.267)",
    fill: "#ffec9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3847",
    "data-name": "Pfad 3847",
    d: "M302.529,525.21a26.889,26.889,0,0,0-11.379,20.235h5.9s2.318-15.172,9.061-20.235Z",
    transform: "translate(-240.388 -409.385)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3848",
    "data-name": "Pfad 3848",
    d: "M302.529,525.21a26.889,26.889,0,0,0-11.379,20.235h5.9s2.318-15.172,9.061-20.235Z",
    transform: "translate(-240.388 -409.385)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3849",
    "data-name": "Pfad 3849",
    d: "M655.447,432.617l-53.524,6.32s-3.54-22.534-2.885-31.3l34.705-1.571a22.084,22.084,0,0,0,2.948-.617v2.091l26.129-6.32S667.246,407.75,655.447,432.617Z",
    transform: "translate(-471.298 -316.37)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3850",
    "data-name": "Pfad 3850",
    d: "M655.447,432.617l-53.524,6.32s-3.54-22.534-2.885-31.3l34.705-1.571a22.084,22.084,0,0,0,2.948-.617v2.091l26.129-6.32S667.246,407.75,655.447,432.617Z",
    transform: "translate(-471.298 -316.37)",
    fill: "#bdbdbd",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3851",
    "data-name": "Pfad 3851",
    d: "M801.46,325.059s11.379-1.474,16.436,8.219l-16.273-.627Z",
    transform: "translate(-623.212 -259.176)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3852",
    "data-name": "Pfad 3852",
    d: "M863.591,363.476c-.447,1.4-.11,2.943,2.481,4.01a4.053,4.053,0,0,0,5.421-2.351c.43-1.289.135-2.748-2.188-3.935A3.934,3.934,0,0,0,863.591,363.476Z",
    transform: "translate(-669.697 -285.976)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3853",
    "data-name": "Pfad 3853",
    d: "M863.591,363.476c-.447,1.4-.11,2.943,2.481,4.01a4.053,4.053,0,0,0,5.421-2.351c.43-1.289.135-2.748-2.188-3.935A3.934,3.934,0,0,0,863.591,363.476Z",
    transform: "translate(-669.697 -285.976)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3854",
    "data-name": "Pfad 3854",
    d: "M115.63,526.88s13.505,6.995,23.2,4.347",
    transform: "translate(-108.717 -410.638)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3855",
    "data-name": "Pfad 3855",
    d: "M117.54,542s8.726,6.73,26.364,5.166",
    transform: "translate(-110.149 -421.981)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3856",
    "data-name": "Pfad 3856",
    d: "M119.15,554.69s8.656,7.512,26.443,5.131",
    transform: "translate(-111.357 -431.5)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3857",
    "data-name": "Pfad 3857",
    d: "M824.205,353.67s-7.04,6.078-13.465,8.826C810.74,362.5,820.5,364.232,824.205,353.67Z",
    transform: "translate(-632.207 -278.571)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3858",
    "data-name": "Pfad 3858",
    d: "M566.1,421.822s33.406,3.155,46.047.2c0,0,.675.447-3.35-1.357Z",
    transform: "translate(-446.65 -330.961)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3859",
    "data-name": "Pfad 3859",
    d: "M1051.712,378.359c-2.081-1.366-5.381-4.2-4.931-7.357.225-1.581-.894-3.06-2.431-4.3,2.8.719,5.366,2.034,4.644,4.407-1.474,4.847,2.528,5.479,2.528,5.479S1051.6,377.235,1051.712,378.359Z",
    transform: "translate(-805.423 -290.474)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3860",
    "data-name": "Pfad 3860",
    d: "M278.107,287.555c.02-.834,0-1.7-.062-2.5a4.272,4.272,0,0,0-.04-.445,8.972,8.972,0,0,1,.749.625l-.412-21.694-2.273-11.364c0-8.059-4.339-10.33-4.339-10.33s-2.273-1.034-2.893-2.478-6.111-4.5-6.113-4.5a15.537,15.537,0,0,1-.05-1.581c0-.137,0-.28.012-.422a6.82,6.82,0,0,0,2.366-8.664c.3,0,.552-.127.667-.58a6.5,6.5,0,0,0-.817-4.732,4.646,4.646,0,0,0-.6-.662,10.237,10.237,0,0,0-.812-.732,3.711,3.711,0,0,0-2.378-1.159,3.56,3.56,0,0,0-1.406.5q-3.3,1.734-6.573,3.5a6.132,6.132,0,0,0-2.2,1.681,6.446,6.446,0,0,0-.949,2.775,6.8,6.8,0,0,0-.092,2.031,2.626,2.626,0,0,0,.8,1.619,1.783,1.783,0,0,0,.307.292,13.513,13.513,0,0,0,1.481.667,6.821,6.821,0,0,0,1.716,2.691c0,.127-.017.25-.027.39-.027.357-.07.749-.125,1.147h0s-1.526-.04-3.8,3.058-7.232,3.512-7.232,3.512-1.859-.827-3.925,8.471-2.686,15.489-1.654,16.528a5.636,5.636,0,0,0,1.464.914,17.94,17.94,0,0,0,5.578,1.749.5.5,0,0,0,.122.2l.147,1.8h0c.125,3.8.27,11.429-.5,13.121a3.516,3.516,0,0,0,.207,3.72l.25-.018a1.9,1.9,0,0,0,.155.225l1-.067c-.072,4.247-.267,10.138-.782,11.432-.827,2.066,0,13.43,0,13.43l-1.446,20.455s-.792,10.677-.05,11.914c-.4,2.221-1.132,6.453-.982,7.507.207,1.446,4.959,3.513,4.959,3.513s5.578,1.249,8.264.827a2.073,2.073,0,0,0,1.966-2,21.574,21.574,0,0,0,5.678.342c2.686-.412,2.273-3.512.827-3.305s-3.1-2.7-4.329-4.147a9.948,9.948,0,0,1-1.5-3.15,1.154,1.154,0,0,0,.68-.362c.62-1.034,1.654-10.537,1.654-10.537l2.686-16.528s1.446-8.059,2.686-9.918c.937-1.4,2.108-11.881,2.626-16.928h.06l.055-.177.777-2.508a3.487,3.487,0,0,0,2.676,1.249c-.13.53-.237.962-.3,1.209-.31,1.249,4.207,3.305,5.3,2.273.457-.432.694-2,.749-3.712h.037ZM250.962,343.9c-.07.4-.14.822-.21,1.249-.157-.5-.282-.949-.367-1.282C250.589,343.875,250.782,343.885,250.962,343.9Z",
    transform: "translate(-199.72 -177.676)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3861",
    "data-name": "Pfad 3861",
    d: "M298.657,707.91s.8,3.582,2,4.974,2.785,4.177,4.177,3.98,1.791,2.786-.8,3.183-7.959-.8-7.959-.8-4.577-2-4.774-3.383,1.194-8.556,1.194-8.556Z",
    transform: "translate(-240.488 -545.993)",
    fill: "#53526b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3862",
    "data-name": "Pfad 3862",
    d: "M298.657,707.91s.8,3.582,2,4.974,2.785,4.177,4.177,3.98,1.791,2.786-.8,3.183-7.959-.8-7.959-.8-4.577-2-4.774-3.383,1.194-8.556,1.194-8.556Z",
    transform: "translate(-240.488 -545.993)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3863",
    "data-name": "Pfad 3863",
    d: "M269.187,714.287s.8,3.582,2,4.974,2.786,4.177,4.177,3.98,1.791,2.786-.8,3.183-7.959-.794-7.959-.794-4.577-2-4.774-3.383,1.194-8.556,1.194-8.556Z",
    transform: "translate(-218.38 -550.779)",
    fill: "#53526b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3864",
    "data-name": "Pfad 3864",
    d: "M311.185,497.86s-1.591,17.11-2.785,18.9-2.586,9.551-2.586,9.551l-2.586,15.916s-1,9.153-1.591,10.148-7.977.567-7.977.567l4.582-52.695Z",
    transform: "translate(-242.271 -388.868)",
    fill: "#5f5d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3865",
    "data-name": "Pfad 3865",
    d: "M311.185,497.86s-1.591,17.11-2.785,18.9-2.586,9.551-2.586,9.551l-2.586,15.916s-1,9.153-1.591,10.148-7.977.567-7.977.567l4.582-52.695Z",
    transform: "translate(-242.271 -388.868)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3866",
    "data-name": "Pfad 3866",
    d: "M292.411,465.21l-.52,1.651-2.81,8.921-.055.17h-.015c-.377.085-8.341,1.916-10.06,2.478a2.438,2.438,0,0,0-.272.1c-.8.4-1.791,14.722-1.791,14.722s-.6,13.53-1,14.525-2,21.485-2.985,20.89-8.157,0-8.157,0c-.8-.8,0-11.539,0-11.539l1.391-19.7s-.8-10.942,0-12.933.8-15.319.8-15.319l16.3-2.523,1.574-.25Z",
    transform: "translate(-220.315 -364.374)",
    fill: "#5f5d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3867",
    "data-name": "Pfad 3867",
    d: "M335.1,470.185l-2.811,8.921-.067.175c-.377.085-8.342,1.916-10.06,2.478h-.172l4.449-11.779.127-.34,1.446.092Z",
    transform: "translate(-263.524 -367.698)",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3868",
    "data-name": "Pfad 3868",
    d: "M293.518,305.93s7.362,7.959,11.939,1.392l4.377,2.985-.8,4.577,2.586,34.62s-6.765-.2-11.539,1.392a7.4,7.4,0,0,1-7.759-1.791l.8-30.441-1.791-9.351Z",
    transform: "translate(-240.523 -244.886)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3869",
    "data-name": "Pfad 3869",
    d: "M293.526,303.54s7.362,7.959,11.939,1.392l4.377,2.985-.8,4.577,2.588,34.63s-6.765-.2-11.539,1.392a7.4,7.4,0,0,1-7.759-1.791l.8-30.441-1.791-9.351Z",
    transform: "translate(-240.531 -243.093)",
    fill: "#53526b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3870",
    "data-name": "Pfad 3870",
    d: "M361.42,468.39s0,5.174,1.194,7.362,8.157,1,8.157,1l-1.392-7.362Z",
    transform: "translate(-293.103 -366.76)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3871",
    "data-name": "Pfad 3871",
    d: "M380.464,488.23c-1.049,1-5.4-1-5.1-2.188.21-.842.944-3.855,1.362-5.564l.29-1.2s2.548-.8,3.448,0a5.673,5.673,0,0,1,.665,2.81C381.314,484.483,381.132,487.6,380.464,488.23Z",
    transform: "translate(-303.554 -374.661)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3872",
    "data-name": "Pfad 3872",
    d: "M311.976,277.315l-6.962,5.371s-10.345-.6-7.759-5.571a18.546,18.546,0,0,0,2-7.03,14.693,14.693,0,0,0,0-2.721s9.551-8.744,8.357,1.194a22.548,22.548,0,0,0-.165,2.3C307.312,278.317,311.976,277.315,311.976,277.315Z",
    transform: "translate(-244.656 -213.288)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3873",
    "data-name": "Pfad 3873",
    d: "M314.824,268.552a22.557,22.557,0,0,0-.165,2.3,6.52,6.52,0,0,1-3.615,1.084c-1.781,0-3.093-1.734-4.277-2.885.132-1.651-.3-1.691-.3-1.691S316.018,258.6,314.824,268.552Z",
    transform: "translate(-251.881 -213.279)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 6.565,
    cy: 6.565,
    r: 6.565,
    transform: "translate(52.598 45.126)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3874",
    "data-name": "Pfad 3874",
    d: "M257.713,293.58s-1.094.1-3.283,3.083-6.977,3.383-6.977,3.383-1.791-.8-3.78,8.157-2.586,14.922-1.591,15.916,4.974,2.388,6.963,2.388c0,0,.6,12.534-.4,14.722a3.391,3.391,0,0,0,.2,3.582l8.744-.6a20.808,20.808,0,0,0,3.582-10.345c.6-6.565,2.586-25.269,1.591-27.458s-5.371-7.759-5.174-8.357A36.557,36.557,0,0,0,257.713,293.58Z",
    transform: "translate(-203.224 -235.621)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3875",
    "data-name": "Pfad 3875",
    d: "M256.56,293.34s-1.471-.04-3.66,2.945-6.963,3.383-6.963,3.383-1.791-.8-3.78,8.157-2.586,14.922-1.586,15.909,4.974,2.388,6.963,2.388c0,0,.6,12.533-.4,14.722a3.391,3.391,0,0,0,.2,3.582l8.744-.6a20.808,20.808,0,0,0,3.582-10.345c.6-6.565,2.586-25.269,1.591-27.458s-5.371-7.759-5.174-8.356S256.56,293.34,256.56,293.34Z",
    transform: "translate(-202.089 -235.441)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3876",
    "data-name": "Pfad 3876",
    d: "M285,376.915s9.955-11.417,8.556-3.582c-1,5.571-4.774,8.556-6.565,9.153S285,376.915,285,376.915Z",
    transform: "translate(-235.774 -293.39)",
    fill: "#fdc2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3877",
    "data-name": "Pfad 3877",
    d: "M385.262,482.087c-.952-.727-2.748-1.859-4.4-1.609l.29-1.2s2.548-.8,3.448,0A5.645,5.645,0,0,1,385.262,482.087Z",
    transform: "translate(-307.687 -374.661)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3878",
    "data-name": "Pfad 3878",
    d: "M336.7,298.36s5.074,3.283,5.671,4.677,2.785,2.388,2.785,2.388,4.177,2.188,4.177,9.948l2.188,10.942-9.953,13.925s-1.194-13.927-1.791-17.31-1.392-9.743-1.392-9.743-2.985-3.78-2.586-4.774S336.7,298.36,336.7,298.36Z",
    transform: "translate(-273.856 -239.207)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3879",
    "data-name": "Pfad 3879",
    d: "M337.3,298.12s5.291,2.945,5.886,4.337,2.788,2.378,2.788,2.378,4.177,2.188,4.177,9.948l2.188,10.942.4,20.89s-3.582-3.383-6.168-1.791-4.177-5.174-4.177-5.174-1.194-13.927-1.791-17.31-1.392-9.743-1.392-9.743-2.985-3.765-2.586-4.764S337.3,298.12,337.3,298.12Z",
    transform: "translate(-274.471 -239.027)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3880",
    "data-name": "Pfad 3880",
    d: "M304.931,229.74a6.5,6.5,0,0,0-1.159-1.144,3.551,3.551,0,0,0-2.291-1.114,3.427,3.427,0,0,0-1.354.485q-3.173,1.671-6.328,3.378a5.884,5.884,0,0,0-2.121,1.619,6.241,6.241,0,0,0-.914,2.673,6.553,6.553,0,0,0-.09,1.954,2.451,2.451,0,0,0,.864,1.641c.567.412,1.344.415,1.819.954a5.314,5.314,0,0,1,.59,1.129c.195.38.532.749.917.682a.963.963,0,0,0,.672-.887,5.381,5.381,0,0,0-.072-1.249,2.958,2.958,0,0,1,.455-2.1c.3-.38.729-.61,1.019-1,.694-.939.377-2.5,1.139-3.38a1.806,1.806,0,0,1,1.749-.5,7.478,7.478,0,0,1,1.749.749,12.989,12.989,0,0,0,2.4.924c.694.19,1.5.645,1.736-.28A6.219,6.219,0,0,0,304.931,229.74Z",
    transform: "translate(-240.005 -186.033)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3881",
    "data-name": "Pfad 3881",
    d: "M304.131,228.94a6.5,6.5,0,0,0-1.159-1.144,3.551,3.551,0,0,0-2.291-1.114,3.427,3.427,0,0,0-1.354.485c-2.113,1.114-3.87.06-6.328,3.378-.525.709-1.579.864-2.121,1.619a6.241,6.241,0,0,0-.914,2.673,6.552,6.552,0,0,0-.09,1.954,2.451,2.451,0,0,0,.864,1.641c.567.412,1.344.415,1.819.954a5.314,5.314,0,0,1,.59,1.129c.195.38.532.749.917.682a.963.963,0,0,0,.672-.887,5.383,5.383,0,0,0-.072-1.249,2.958,2.958,0,0,1,.455-2.1c.3-.38.729-.61,1.019-1,.695-.939.377-2.5,1.139-3.38a1.806,1.806,0,0,1,1.749-.5,7.477,7.477,0,0,1,1.749.749,12.991,12.991,0,0,0,2.4.924c.694.19,1.5.645,1.736-.28A6.147,6.147,0,0,0,304.131,228.94Z",
    transform: "translate(-239.404 -185.433)",
    fill: "#865a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3882",
    "data-name": "Pfad 3882",
    d: "M258.056,353.71s-.2,7.362-1.194,8.356.6,2.188.6,2.188l3.98-1s-1,6.565,3.183,5.771c0,0-2.785,2.586-5.571,2.985s-2.593-.595-2.593-.595l-4.177-4.974Z",
    transform: "translate(-211.229 -280.729)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3883",
    "data-name": "Pfad 3883",
    d: "M271.058,357.29s-2.653,6.765-.662,9.551l4.377-1s-3.98,1.194-3.383-1.194S271.058,357.29,271.058,357.29Z",
    transform: "translate(-224.263 -283.415)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3884",
    "data-name": "Pfad 3884",
    d: "M269.43,421.8s5.771.4,7.362-.8a15.239,15.239,0,0,1-7.182,3Z",
    transform: "translate(-224.094 -331.209)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3885",
    "data-name": "Pfad 3885",
    d: "M369,373.22s2.985,9.153,2.785,10.545-.6,16.713-.6,16.713l-.6-.2.2-16.713Z",
    transform: "translate(-298.79 -295.365)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3886",
    "data-name": "Pfad 3886",
    d: "M870.036,476.83s4.372,8.581.809,13.275.325,17.487.325,17.487",
    transform: "translate(-674.136 -373.091)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3887",
    "data-name": "Pfad 3887",
    d: "M870.008,457.138a1.745,1.745,0,1,1-1.214-3A5.056,5.056,0,0,1,870.008,457.138Z",
    transform: "translate(-672.814 -356.07)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3888",
    "data-name": "Pfad 3888",
    d: "M874.563,476.83s-4.372,8.581-.809,13.275-.325,17.487-.325,17.487",
    transform: "translate(-676.397 -373.091)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3889",
    "data-name": "Pfad 3889",
    d: "M876,457.138a1.745,1.745,0,1,0,1.214-3A5.056,5.056,0,0,0,876,457.138Z",
    transform: "translate(-679.131 -356.07)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3890",
    "data-name": "Pfad 3890",
    d: "M876,457.138a1.745,1.745,0,1,0,1.214-3A5.056,5.056,0,0,0,876,457.138Z",
    transform: "translate(-679.131 -356.07)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3891",
    "data-name": "Pfad 3891",
    d: "M886.236,476.83s4.372,8.581.809,13.275.325,17.487.325,17.487",
    transform: "translate(-686.289 -373.091)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3892",
    "data-name": "Pfad 3892",
    d: "M886.208,457.138a1.745,1.745,0,1,1-1.214-3A5.056,5.056,0,0,1,886.208,457.138Z",
    transform: "translate(-684.967 -356.07)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3893",
    "data-name": "Pfad 3893",
    d: "M881.913,484.658a5.048,5.048,0,0,1-2.953,1.317,4.3,4.3,0,0,1,4.154-4.314A5.039,5.039,0,0,1,881.913,484.658Z",
    transform: "translate(-681.351 -376.715)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3894",
    "data-name": "Pfad 3894",
    d: "M882.363,508.35a5.048,5.048,0,0,1-2.953,1.317,4.284,4.284,0,1,1,2.953-1.317Z",
    transform: "translate(-681.689 -394.486)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3895",
    "data-name": "Pfad 3895",
    d: "M857.69,525.986a1.744,1.744,0,1,1-2.88-1.466A5.045,5.045,0,0,1,857.69,525.986Z",
    transform: "translate(-663.234 -408.867)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3896",
    "data-name": "Pfad 3896",
    d: "M860.858,477.833a5.046,5.046,0,0,1,1.826,2.668,5.083,5.083,0,0,1-3.168-.635,5.027,5.027,0,0,1-1.826-2.668A5.008,5.008,0,0,1,860.858,477.833Z",
    transform: "translate(-665.395 -373.338)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3897",
    "data-name": "Pfad 3897",
    d: "M860.858,477.833a5.046,5.046,0,0,1,1.826,2.668,5.083,5.083,0,0,1-3.168-.635,5.027,5.027,0,0,1-1.826-2.668A5.008,5.008,0,0,1,860.858,477.833Z",
    transform: "translate(-665.395 -373.338)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3898",
    "data-name": "Pfad 3898",
    d: "M890.762,476.83s-4.372,8.581-.809,13.275-.325,17.487-.325,17.487",
    transform: "translate(-688.549 -373.091)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3899",
    "data-name": "Pfad 3899",
    d: "M892.21,457.138a1.745,1.745,0,1,0,1.214-3A5.056,5.056,0,0,0,892.21,457.138Z",
    transform: "translate(-691.291 -356.07)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3900",
    "data-name": "Pfad 3900",
    d: "M892.21,457.138a1.745,1.745,0,1,0,1.214-3A5.056,5.056,0,0,0,892.21,457.138Z",
    transform: "translate(-691.291 -356.07)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3901",
    "data-name": "Pfad 3901",
    d: "M889.859,490.322a5.116,5.116,0,0,0-1.249,3,5.041,5.041,0,0,0,2.968-1.282,5.116,5.116,0,0,0,1.249-3A5.035,5.035,0,0,0,889.859,490.322Z",
    transform: "translate(-688.59 -382.251)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3902",
    "data-name": "Pfad 3902",
    d: "M889.859,490.322a5.116,5.116,0,0,0-1.249,3,5.041,5.041,0,0,0,2.968-1.282,5.116,5.116,0,0,0,1.249-3A5.035,5.035,0,0,0,889.859,490.322Z",
    transform: "translate(-688.59 -382.251)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3903",
    "data-name": "Pfad 3903",
    d: "M898.969,523.152a5.116,5.116,0,0,0-1.249,3,5.04,5.04,0,0,0,2.968-1.282,5.116,5.116,0,0,0,1.249-3A5,5,0,0,0,898.969,523.152Z",
    transform: "translate(-695.425 -406.879)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3904",
    "data-name": "Pfad 3904",
    d: "M889.31,507.017s2.631-4.147,6.325-4.247",
    transform: "translate(-689.115 -392.551)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3905",
    "data-name": "Pfad 3905",
    d: "M862.115,496.987s-2.631-4.147-6.325-4.247",
    transform: "translate(-663.969 -385.027)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3906",
    "data-name": "Pfad 3906",
    d: "M879.74,520.687s2.631-4.147,6.325-4.247",
    transform: "translate(-681.936 -402.806)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(205.715 109.514)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(191.201 107.066)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3907",
    "data-name": "Pfad 3907",
    d: "M868.5,526.157s-2.631-4.147-6.325-4.247",
    transform: "translate(-668.756 -406.909)",
    fill: "none",
    stroke: "#b9f6ca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(192.795 114.353)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_532",
    "data-name": "Ellipse 532",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(203.497 112.987)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3908",
    "data-name": "Pfad 3908",
    d: "M870.946,561.3s-6.34-1.269-8.032-2.96-9.3-4.642-10.145-2.536-11.414,9.308-4.234,10.575,16.91,1.691,19.024.844S870.946,561.3,870.946,561.3Z",
    transform: "translate(-656.662 -431.791)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3909",
    "data-name": "Pfad 3909",
    d: "M848.529,584.182c7.187,1.269,16.91,1.691,19.024.844,1.609-.645,2.728-3.747,3.17-5.176l.212.045s-1.269,5.074-3.383,5.918-11.836.422-19.024-.844c-2.074-.367-2.668-1.227-2.443-2.313C846.268,583.362,846.99,583.91,848.529,584.182Z",
    transform: "translate(-656.656 -450.375)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3910",
    "data-name": "Pfad 3910",
    d: "M183.975,664.66s2.093,2.748-.967,6.87-5.583,7.622-4.562,10.2c0,0,4.617-7.677,8.374-7.784S188.107,669.277,183.975,664.66Z",
    transform: "translate(-155.667 -513.998)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3911",
    "data-name": "Pfad 3911",
    d: "M184.331,664.66a3.389,3.389,0,0,1,.427.859c3.667,4.307,5.618,8.326,2.1,8.429-3.283.095-7.22,5.963-8.164,7.447a3.178,3.178,0,0,0,.112.337s4.617-7.677,8.374-7.784S188.463,669.277,184.331,664.66Z",
    transform: "translate(-156.023 -513.998)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3912",
    "data-name": "Pfad 3912",
    d: "M215.35,676.781c0,.964-.107,1.749-.25,1.749s-.25-.782-.25-1.749.135-.5.267-.5S215.35,675.819,215.35,676.781Z",
    transform: "translate(-183.149 -522.631)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3913",
    "data-name": "Pfad 3913",
    d: "M217.234,681.249c-.847.462-1.584.75-1.646.622s.57-.587,1.416-1.047.512-.125.577,0S218.08,680.787,217.234,681.249Z",
    transform: "translate(-183.699 -525.948)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3914",
    "data-name": "Pfad 3914",
    d: "M142.893,664.66s-2.093,2.748.967,6.87,5.583,7.622,4.562,10.2c0,0-4.617-7.677-8.374-7.784S138.761,669.277,142.893,664.66Z",
    transform: "translate(-125.644 -513.998)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3915",
    "data-name": "Pfad 3915",
    d: "M142.893,664.66a3.39,3.39,0,0,0-.427.859c-3.667,4.307-5.618,8.326-2.1,8.429,3.283.095,7.22,5.963,8.164,7.447a3.171,3.171,0,0,1-.112.337s-4.617-7.677-8.374-7.784S138.761,669.277,142.893,664.66Z",
    transform: "translate(-125.644 -513.998)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3916",
    "data-name": "Pfad 3916",
    d: "M141.42,676.781c0,.964.107,1.749.25,1.749s.25-.782.25-1.749-.135-.5-.267-.5S141.42,675.819,141.42,676.781Z",
    transform: "translate(-128.064 -522.631)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3917",
    "data-name": "Pfad 3917",
    d: "M134.53,681.249c.847.462,1.584.75,1.646.622s-.57-.587-1.416-1.047-.512-.125-.577,0S133.683,680.787,134.53,681.249Z",
    transform: "translate(-122.507 -525.948)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3918",
    "data-name": "Pfad 3918",
    d: "M144.09,722.056s5.853-.18,7.617-1.437,8.994-2.748,9.441-.749,8.8,10.02,2.188,10.073-15.354-1.029-17.115-2.1S144.09,722.056,144.09,722.056Z",
    transform: "translate(-130.067 -554.683)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3919",
    "data-name": "Pfad 3919",
    d: "M163.464,738.73c-6.608.052-15.354-1.029-17.115-2.1-1.342-.817-1.876-3.747-2.054-5.1H144.1s.37,4.722,2.131,5.793,10.507,2.156,17.115,2.1c1.909-.015,2.566-.694,2.531-1.7C165.61,738.34,164.883,738.717,163.464,738.73Z",
    transform: "translate(-130.074 -564.162)",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNologBooks);
export default __webpack_public_path__ + "static/media/NologBooks.588c06afe99ac662d0efa346dbb33a26.svg";
export { ForwardRef as ReactComponent };